import React from 'react';
import { Grid, GridColumn as Column, GridNoRecords } from '@progress/kendo-react-grid';
import { useTranslation } from 'react-i18next';

const SystemLogGrid = (props) => {
    // * we call the hook to make translations
    const { t } = useTranslation('common');

    return(
        <>
            <Grid style={{ height: 'calc(70vh)' }} data={[...props.data]} resizable={true}>
                {/* this is the message when there are no records */}
                <GridNoRecords>{t('grids.no_records')}</GridNoRecords>
                {/* columns of the grid */}
                <Column field="id" title={t('log.column_id')} width="60"/>
                <Column field="logDateTime" title={t('log.column_date')} width="180"/>
                <Column field="categoryString" title={t('log.column_category')} width="110"/>
                <Column field="eventTypeString" title={t('log.column_type')} width="110" />
                <Column field="userCode" title={t('log.column_userCode')} width="110" />
                <Column field="userName" title={t('log.column_userName')} width="110" />
                <Column field="message" title={t('log.column_message')} width="270" />
                <Column field="detail" title={t('log.column_eventDetail')} />
            </Grid>
        </>
    );

}

export default SystemLogGrid